import { Component, Input, inject } from "@angular/core";

import { LoadingBarModule } from "@ngx-loading-bar/core";

import { LogoComponent } from "@hermes/aphrodite-logo";
import { AnalyticsService } from "@hermes/hermes-web-fragments-analytics";
import { BackToHomeButtonComponent } from "@hermes/hermes-web-fragments-back-to-home-button";

import { HeaderClickEvent } from "../../events/header-click.event";
import { BackButtonCheckoutComponent } from "../back-button-checkout/back-button-checkout.component";

@Component({
    selector: "h-header-light",
    imports: [
        LoadingBarModule,
        BackToHomeButtonComponent,
        BackButtonCheckoutComponent,
        LogoComponent,
    ],
    templateUrl: "./header-light.component.html",
    styleUrls: ["./header-light.component.scss"],
})
export class HeaderLightComponent {
    private analyticsService = inject(AnalyticsService);

    @Input()
    public displayBackToHome: boolean = false;

    public onLogoClick(): void {
        this.analyticsService.sendData(
            new HeaderClickEvent({
                eventaction: "Logo",
            }),
        );
    }
}
